/**
 * Auth API surface. Matches the Lambda handlers in /api/src/handlers/.
 */
import { apiCall, type ApiResult } from "./api";
import type { Industry } from "../types";

export interface SignupInput {
  firstName: string;
  lastName: string;
  email: string;
  company?: string;
  industry: Industry;
  password: string;
  agreedToTerms: true;
}

export const auth = {
  signup: (input: SignupInput): Promise<ApiResult> =>
    apiCall("/api/auth/signup", { method: "POST", body: input, auth: false }),

  login: (email: string, password: string): Promise<ApiResult> =>
    apiCall("/api/auth/login", { method: "POST", body: { email, password }, auth: false }),

  me: (): Promise<ApiResult> => apiCall("/api/auth/me", { method: "GET" }),

  forgotPassword: (email: string): Promise<ApiResult> =>
    apiCall("/api/auth/forgot-password", { method: "POST", body: { email }, auth: false }),

  verifyResetToken: (token: string): Promise<ApiResult> =>
    apiCall(`/api/auth/verify-reset-token/${encodeURIComponent(token)}`, {
      method: "GET",
      auth: false,
    }),

  resetPassword: (token: string, password: string): Promise<ApiResult> =>
    apiCall("/api/auth/reset-password", {
      method: "POST",
      body: { token, password },
      auth: false,
    }),
};

export const contact = {
  submit: (input: {
    name: string;
    email: string;
    company?: string;
    message: string;
  }): Promise<ApiResult> =>
    apiCall("/api/contact", { method: "POST", body: input, auth: false }),
};
